export const isReturnPage = (pathname: string) => {
  const regex = /^\/order\/(\[?[a-zA-Z0-9\-]+\]?)\/return$/;
  return regex.test(pathname);
};
